
export interface ModuleData {
  ID: number;
  ROLEID: number;
  MODULEID: number;
  CREATEPERM: boolean;
  READPERM: boolean;
  UPDATEPERM: boolean;
  DELETEPERM: boolean;
  STATUS: boolean;
  createdAt: string;
  updatedAt: string;
  moduleInfo: {
    ID: number;
    OUID: number;
    MODULENAME: string; 
    MODULEDESC: string;
    ROUTE: string;
    ACTIVE: boolean;
    REVEAL: boolean;
    SEQUENCE: number;
    createdAt: string;
    updatedAt: string;
  };
}

export interface AppRoute {
  path: string;
  component: string; 
  protected: boolean;
  requiredRoute?: string;
}

/**
 * Converts module list to app route definitions
 */
export const createRoutesFromModules = (modules: ModuleData[]): AppRoute[] => {
  if (!Array.isArray(modules) || modules.length === 0) {
    console.warn('⚠️ No valid modules data available.');
    return [];
  }

  return modules
    .filter(({ moduleInfo, READPERM }) => 
      moduleInfo?.ACTIVE && READPERM && !!moduleInfo.ROUTE
    )
    .map(({ moduleInfo }) => ({
      path: `/${moduleInfo.ROUTE}`,
      component: moduleInfo.MODULENAME.trim(), // normalized
      protected: true,
      requiredRoute: moduleInfo.ROUTE,
    }));
};
